import React, { useContext, useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { MdOutlineWarning } from "react-icons/md";

import AmountFound from "../features/AmountFound";
import StyledButton from "../components/StyledButton";
import { green } from "../config";
import { LangContext } from "../contexts/langContext";
import useShowingCorrectAnswer from "../hooks/useShowingCorrectAnswer";
import { SelectAnswerContext } from "../contexts/selectAnswerContext";

interface RenderProps {
  readOnly?: boolean;
  showCorrect?: boolean;
}

const FakeDomain: React.FC<{
  [key in keyof RenderProps]: RenderProps[key];
}> = ({ readOnly = false, showCorrect = false }) => {
  const { translatePageText } = useContext(LangContext);
  const { onSelectAnswer } = useContext(SelectAnswerContext);
  const [scams, setScams] = useState({
    httpFound: false,
    finalDomainScam: false,
  });
  const theme = useTheme();
  const isMediumDeviceOrDown = useMediaQuery(theme.breakpoints.down("md"));
  const showingCorrectAnswer = useShowingCorrectAnswer();
  const displayCorrectAnswers = showCorrect || showingCorrectAnswer;

  const handleFound = (newState: any) => {
    setScams(newState);
    if (Object.values(newState).every((v) => v === true)) {
      const answerStats = { val1: 0, val2: 1, val3: 0 };
      onSelectAnswer("correct", answerStats);
    }
  };

  return (
    <>
      <AmountFound
        scams={scams}
        amountFound={Object.values(scams).filter((x) => x === true).length}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          fontFamily: "arial",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            background: "white",
            borderRadius: 12,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: "100%",
              textAlign: "center",
              display: "flex",
              padding: isMediumDeviceOrDown ? 0 : "0 15px",
              alignItems: "center",
              background: "rgba(0,0,0,0.1)",
            }}
          >
            <Box sx={{ display: { xs: "none", sm: "flex" } }}>
              <div
                style={{
                  background: "#FF3854",
                  borderRadius: 20,
                  width: 14,
                  height: 14,
                  margin: "6px 3px",
                }}
              />
              <div
                style={{
                  background: "#FDCF35",
                  borderRadius: 20,
                  width: 14,
                  height: 14,
                  margin: "6px 3px",
                }}
              />
              <div
                style={{
                  background: "lightgreen",
                  borderRadius: 20,
                  width: 14,
                  height: 14,
                  margin: "6px 3px",
                }}
              />
            </Box>

            <div
              style={{
                flex: 1,
                background: "white",
                borderRadius: 20,
                margin: 6,
                textAlign: "start",
                position: "relative",
                width: "calc(100% - 200px)",
              }}
            >
              <p
                style={{
                  padding: "6px 0",
                  margin: "2px 0 0 10px",
                  color: "grey",
                  fontSize: isMediumDeviceOrDown ? "0.9rem" : "1em",
                }}
              >
                <span
                  style={{
                    borderRadius: 1000,
                    border: "3px solid transparent",
                    outline:
                      scams.httpFound || displayCorrectAnswers
                        ? `3px solid ${green[500]}`
                        : "0px solid rgba(0,0,0,0)",
                    background:
                      scams.httpFound || displayCorrectAnswers ? "rgba(62,189,147,0.3)" : "none",
                  }}
                  onClick={() =>
                    !readOnly ? handleFound({ ...scams, httpFound: true }) : undefined
                  }
                >
                  <MdOutlineWarning
                    style={{
                      fontSize: isMediumDeviceOrDown ? "1rem" : "1.2em",
                      marginBottom: -3,
                      color: "red",
                    }}
                  />
                  | http://
                </span>
                instagram.com.
                <span
                  style={{
                    borderRadius: 1000,
                    border: "3px solid transparent",
                    outline:
                      scams.finalDomainScam || displayCorrectAnswers
                        ? `3px solid ${green[500]}`
                        : "0px solid rgba(0,0,0,0)",
                    background:
                      scams.finalDomainScam || displayCorrectAnswers
                        ? "rgba(62,189,147,0.3)"
                        : "none",
                  }}
                  onClick={() =>
                    !readOnly ? handleFound({ ...scams, finalDomainScam: true }) : undefined
                  }
                >
                  utm-srcigweb.se
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <StyledButton
        hasCooldown
        variant="secondary"
        onClick={() => {
          const answerStats = { val1: 0, val2: 0, val3: 1 };
          onSelectAnswer("incorrect", answerStats);
        }}
        style={{ marginTop: 10 }}
        label={translatePageText("renderTemplates.fakeDomainDontKnow")}
        disabled={readOnly || false}
      />
    </>
  );
};

export default FakeDomain;
